import { createTheme } from "@mui/material/styles";
import themeOptions from "./themeOptions";
import themeOverrides from "./themeOverrides";

const theme = createTheme({ ...themeOptions, ...themeOverrides });
export const ltrTheme = createTheme({
  ...themeOptions,
  ...themeOverrides,
  direction: "ltr",
});

export default theme;
